import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_STARTER_IN_HEADER_ENABLED = defineFcm('petition_page_starter_in_header_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Petition page',
		description: 'Controls visibility of the starter hero in the petition page header',
		import: false,
	});
